import React, { useEffect, useState } from 'react'
import Select, { SingleValue } from "react-select";
import ToastMessage from '../../../../common/ToastMessage';
import useStatuses from '../../../../store/ReactQueries/statuses/useStatus';
import useLocations from '../../../../store/ReactQueries/locations/useLocation';
import useCustomers from '../../../../store/ReactQueries/customers/useCustomer';
import useCategory from '../../../../store/ReactQueries/categories/useCategory';
import usePriorities from '../../../../store/ReactQueries/priorities/usePriority';
import useCompany from '../../../../store/ReactQueries/general/company/useCompany';
import useDepartment from '../../../../store/ReactQueries/departments/useDepartment';
import useContractors from '../../../../store/ReactQueries/contractors/useContractor';
import useInterventionTypes from '../../../../store/ReactQueries/interventionTypes/useInterventionType';
import useAddUserGlobalFilter from '../../../../store/ReactQueries/globalFilters/useAddUserGlobalFilter';
import useUpdateUserGlobalFilter from '../../../../store/ReactQueries/globalFilters/useUpdateUserGlobalFilter';
import useGetAllUserGlobalFilters from '../../../../store/ReactQueries/globalFilters/useGetAllUserGlobalFilters';
import { useDarkModeStore } from '../../../../store/useDarkModeStore';
import { darkModeBackgroudInputs } from '../../../../utils/constants';
import { useLanguageStore } from '../../../../store/useLanguageStore';
import { UserGlobalFilter } from '../../../../models/UserModel/UserGlobalFilter';

interface GlobalFilterViewInputProps {
    userId: string;
    fieldName: string;
}

const useDataByFieldName = (fieldName: string) => {
    const hooksMap: Record<string, () => any> = {
        CompanyId: () => useCompany(0, 0),
        StatusId: () => useStatuses(0, 0),
        LocationId: () => useLocations(0, 0),
        CustomerId: () => useCustomers(0, 0),
        CategoryId: () => useCategory(0, 0),
        PriorityId: () => usePriorities(0, 0),
        DepartmentId: () => useDepartment(0, 0),
        ContractorId: () => useContractors(0, 0),
        InterventionTypeId: () => useInterventionTypes(0, 0),
    };

    return hooksMap[fieldName]?.() || {};
};

export const GlobalFiterSelectItem: React.FC<GlobalFilterViewInputProps> = ({ fieldName, userId }) => {

    const { language } = useLanguageStore();
    const { darkMode } = useDarkModeStore();
    const { data, error } = useDataByFieldName(fieldName);
    const { data: globalFilters } = useGetAllUserGlobalFilters(userId);

    const initialValue: UserGlobalFilter = {
        id: '',
        userId: userId,
        fieldName: '',
        value: '',
    }
    const [globalFilterById, setGlobalFilterById] = useState<UserGlobalFilter>(initialValue);

    const addGlobalFilter = useAddUserGlobalFilter(userId);
    const updateGlobalFilter = useUpdateUserGlobalFilter(userId);

    useEffect(() => {
        const globalFilterById = globalFilters?.find(item => item.fieldName === fieldName);
        if (globalFilterById) {
            setGlobalFilterById(globalFilterById);
            const dataByValue = data?.find((item: any) => item.id == globalFilterById?.value);
            if (dataByValue) setGlobalFilterById({ ...globalFilterById, fieldName: dataByValue.title });
        } else setGlobalFilterById(initialValue);
    }, [data]);

    const handleMultiSelect = (
        selectedOption: SingleValue<{
            label: any;
            value: string;
        }>
    ) => {
        if (!selectedOption) {
            setGlobalFilterById(initialValue);
            return;
        }

        let upGlobalFilterById = {
            ...globalFilterById,
            value: selectedOption.value ?? '',
            fieldName: selectedOption.label ?? ''
        }

        const isUpdate = globalFilters?.find(item => item.fieldName === fieldName);

        if (isUpdate) updateGlobalFilter.mutate({ ...isUpdate, value: selectedOption.value || '' });
        else addGlobalFilter.mutate({ ...upGlobalFilterById, fieldName });

        setGlobalFilterById(upGlobalFilterById);
    };

    useEffect(() => {
        if (error) ToastMessage.Failed(`Error: ${error.message}`);
    }, [error]);

    const label = fieldName.replace(/Id$/, "");

    return <div className='w-100'>
        <label className={darkMode ? 'text-white' : 'text-muted'}>{language[label] ?? label}</label>
        <Select
            value={{ label: globalFilterById.fieldName, value: globalFilterById.value }}
            className={`${darkMode && "dark-mode-input"}`}
            onChange={handleMultiSelect}
            placeholder="Zgjedh"
            options={data?.map((item: any) => ({
                value: item.id ?? "",
                label: item.title ?? '',
            }))}
            styles={{
                menu: (provided) => ({ ...provided, zIndex: 11 }),
                container: (provided) => ({
                    ...provided,
                    position: "relative",
                    zIndex: 11,
                }),
                singleValue: (provided) => ({
                    ...provided,
                    color: darkMode ? 'white' : 'black',
                }),
                menuPortal: (base) => ({ ...base, zIndex: 11 }),
                control: (provided) => ({
                    ...provided,
                    height: 50,
                    borderColor: darkMode ? darkModeBackgroudInputs : "initial",
                    backgroundColor: darkMode ? darkModeBackgroudInputs : "white",
                }),
            }}
            menuPlacement="top"
            menuPortalTarget={document.body}
        />
    </div>
}
export default GlobalFiterSelectItem;